export const isDefined = <T>(value: T | undefined): value is T =>
  value !== undefined

export const firstDefined = <T>(...args: T[]) => args.find(isDefined)
